export default __webpack_public_path__ + "images/search-angle-down_fa4fe311f5bdaf5dc830611a7db3a309.svg";